( function ( $, undefined ) {
	var Field = acf.models.SelectField.extend( {
		type: 'user',
	} );

	acf.registerFieldType( Field );

	acf.addFilter(
		'select2_ajax_data',
		function ( data, args, $input, field, select2 ) {
			if ( ! field ) {
				return data;
			}

			const $query_nonce = $(
				`#acf-${ field.get( 'key' ) }-query-nonce`
			);
			if ( $query_nonce.length ) {
				data.user_query_nonce = $query_nonce.val();
			}

			return data;
		}
	);
} )( jQuery );
